import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";
import { ApolloLink } from "apollo-link";

import { onError } from "apollo-link-error";

var CLIENT_URL = "";
if (process.env.NODE_ENV === "development")
  CLIENT_URL = process.env.APP_DEV_URL;
else CLIENT_URL = process.env.APP_PROD_URL;

console.log(process.env.REACT_APP_ENDPOINT);

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.map(({ message, locations, path }) =>
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
          )
        );
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    createUploadLink({
      uri: "https://node-test.mydetail.io/"
    })
  ]),
  cache: new InMemoryCache()
});

export default client;
